'use strict'

export default function sortByDate(reportA, reportB) {
  return new Date(reportA.date).toISOString().slice(0,10)<new Date(reportB.date).toISOString().slice(0,10)
    ? -1
    : new Date(reportA.date).toISOString().slice(0,10)>new Date(reportB.date).toISOString().slice(0,10)
      ? 1
      : new Date(reportA.timestamp)<new Date(reportB.timestamp)
        ? -1
        : new Date(reportA.timestamp)>new Date(reportB.timestamp)
          ? 1
          : 0;
}

module.exports=sortByDate;



// WEBPACK FOOTER //
// ./app/utils/sortByDate.js